import { motion } from "framer-motion";
import { Phone, MessageSquareText, Mail, Clock, MapPin } from "lucide-react";
import { Seo } from "../seo";
import { QuoteForm } from "../components/QuoteForm";
import { PHONE_TEL, PHONE_SMS, PHONE_DISPLAY, AREAS } from "../site";

const EMAIL = "arrowlocksmith204@gmail.com";

const METHODS = [
  {
    icon: Phone,
    label: "Call — fastest",
    value: PHONE_DISPLAY,
    href: PHONE_TEL,
    testId: "contact-call-link",
  },
  {
    icon: MessageSquareText,
    label: "Text us",
    value: "Send an SMS anytime",
    href: PHONE_SMS,
    testId: "contact-text-link",
  },
  {
    icon: Mail,
    label: "Email",
    value: EMAIL,
    href: `mailto:${EMAIL}`,
    testId: "contact-email-link",
  },
];

export default function ContactPage() {
  return (
    <main className="pt-28 md:pt-36">
      <Seo
        title="Contact Arrow Locksmith | 24/7 Locksmith Winnipeg — Call (204) 963-9081"
        description="Reach Arrow Locksmith 24/7 anywhere in Winnipeg. Call or text (204) 963-9081, email arrowlocksmith204@gmail.com, or request a quote online — we reply by phone within minutes."
        path="/contact"
      />
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ type: "spring", stiffness: 100, damping: 20 }}
          className="max-w-3xl"
        >
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-zinc-400 mb-4">Contact</p>
          <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold tracking-tighter leading-[1.02] text-zinc-950">
            One call. <span className="text-brand">A van on its way.</span>
          </h1>
          <p className="mt-6 text-base md:text-lg leading-relaxed text-zinc-600">
            Locked out or planning ahead — reach us whichever way is easiest.
            Phone and text are answered around the clock.
          </p>
        </motion.div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {METHODS.map((m, i) => (
            <motion.a
              key={m.label}
              href={m.href}
              data-testid={m.testId}
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ type: "spring", stiffness: 100, damping: 20, delay: 0.1 + i * 0.08 }}
              className="group rounded-3xl bg-white border border-zinc-200 p-8 hover:-translate-y-1 hover:border-brand transition-[transform,border-color] duration-200"
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-brand/10 mb-5">
                <m.icon className="h-6 w-6 text-brand" />
              </span>
              <p className="font-mono text-xs uppercase tracking-[0.2em] text-zinc-400">{m.label}</p>
              <p className="mt-2 font-heading text-lg font-semibold text-zinc-950 group-hover:text-brand transition-colors">
                {m.value}
              </p>
            </motion.a>
          ))}
        </div>

        <div className="mt-8 flex flex-wrap gap-x-10 gap-y-3 text-sm text-zinc-600">
          <p className="flex items-center gap-2.5">
            <Clock className="h-4 w-4 text-brand" /> Open 24 hours, 7 days a week
          </p>
          <p className="flex items-center gap-2.5">
            <MapPin className="h-4 w-4 text-brand" /> {AREAS.slice(0, 8).join(" · ")} · and all of Winnipeg
          </p>
        </div>
      </div>

      <QuoteForm />
    </main>
  );
}
